import $ from 'jquery';

import Swiper, { Navigation, Pagination } from 'swiper';

export default () => {
    //console.log("colonne slider");
    var swiper = new Swiper(".col-swiper", {
        modules: [Pagination],
        loop: true,
        effect: "fade",
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
};



// WEBPACK FOOTER //
// ../views/componente-tre-colonne-slider/tre-colonne-slider.js